var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h3',{staticStyle:{"font-weight":"black","font-size":"23px","margin-bottom":"10px"}},[_vm._v(" "+_vm._s(_vm.title ?? "산출내역서")+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }